export default __webpack_public_path__ + "static/media/new-users.9a4800fa.svg";